import { CSSField } from "@/types/css"
import { CSSLineType } from "../CSSEditor"
import { getScreenDimensions } from "@/utils/screen"
import findCSSValueInArray from "@/utils/findCSSValueInArray"

type Args = {
    element:any
    cssArray:CSSField[]
}

const getSpecifiedWidth = ({element,cssArray}:Args)=>{
    const elementClass = element.class||element.classString?.replace("sub-section ","");
    let width = findCSSValueInArray({classString:elementClass,property:'width',cssArray})
    if(width?.includes("vw")){
        const screenWidth = getScreenDimensions().width
        const perc = parseFloat(width.replace("vw",""))
        return screenWidth*perc/100
    }
    return width?parseInt(width?.replaceAll("px","")):null
}

export default getSpecifiedWidth